import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import clsx from 'clsx';
import { SaleTagIcon } from '@components/icons/SaleTagIcon';

function CryptoCard({ checkout_link }) {
  const { t: tt } = useTranslation('plans');

  const router = useRouter();

  const discountCodeTitle = tt('crypto.discount_tooltip');

  const handleCopyCode = async (e) => {
    const textArea = document.createElement('textarea');
    textArea.value = e.target.innerHTML;

    textArea.select();
    textArea.setSelectionRange(0, 999999);
    await navigator.clipboard.writeText(textArea.value);

    textArea.remove();
  };

  return (
    <section
      className={clsx(
        'relative',
        'max-w-sm',
        'p-[32px]',
        'flex flex-col justify-between gap-[48px]',
        'border border-white/40 rounded-[10px]',
      )}
    >
      <div className="absolute -top-[2px] -right-[30px]">
        <SaleTagIcon size={60} />
      </div>

      <div className="flex flex-col gap-[16px]">
        <h2
          className={clsx(
            'm-0',
            'text-[24px] leading-normal',
            'lg:text-[30px] leading-tight',
            'text-white font-medium',
          )}
        >
          {tt('crypto.title-right')}
        </h2>

        <p className="m-0">{tt('crypto.description')}</p>

        <p className="m-0">
          <Trans t={tt} i18nKey="crypto.discount">
            Apply the{' '}
            <button
              className="font-bold underline decoration-1 underline-offset-4 cursor-pointer"
              onClick={handleCopyCode}
              title={discountCodeTitle}
            >
              CRYPTOSTART
            </button>{' '}
            discount code for more savings!
          </Trans>
        </p>
      </div>

      <button
        type="button"
        onClick={() => router.push(checkout_link)}
        className={clsx(
          'w-full',
          'px-4 py-2',
          'rounded-md',
          'font-semibold',
          'tracking-wide text-white',
          'bg-blue-600 hover:bg-blue-500 focus:bg-blue-500',
          'outline-none',
          'focus:ring focus:ring-blue-300/80',
          'transition-colors duration-300',
        )}
      >
        {tt('crypto.cta')}
      </button>
    </section>
  );
}

export default CryptoCard;
